/* eslint-disable indent */
    'use strict';

    const trackingUtils = require('../modules/utils/tracking.utils');
    const xsellController = import(/* webpackChunkName: "module-xsell" */ 'od-modules/xsell/controller');

    const postBookingTripCategory = 'accommodationPostBooking';

    Odigeo.defineWidget('confirmation_manager', Odigeo.Widget.extend({
        modelClass: Odigeo.Model.extend({
            bookingConfirmedUrl: 'confirmed',
            bookingPendingUrl: 'pending',
            bookingRejectedUrl: 'rejected',
            bookingRetainedUrl: 'retained',
            bookingBankTransfer: 'banktransfer',
            connect: true,
            selectors: ['bookingId'],

            clearShoppingBasket: function(bookingStatus) {
                this.fetch({
                    type: 'POST',
                    contentType: 'application/json',
                    dataType: 'json',
                    url: Odigeo.Settings.property('serviceUrlFormatter')('accommodationpostbooking/clearshoppingbasket'),
                    data: bookingStatus,
                });
            },
        }),

        viewClass: Odigeo.View.extend({
            currency: null,

            // Pending confirmation params
            pendingSelectors: {
                extraInfoContainer: 'extra_info_container',
                extraInfoBtn: 'extra_info_btn',
                angleIcon: 'extra_info_btn_icon',
                confirmationMsg: 'confirmation_msg',
                confirmationMsgOpen: 'confirmation_msg_open',
                mainInfoContainer: 'main_info_block',
            },
            isPendingDomBinded: false,
            emergingLayer: null,

            init: function() {
                this.cacheDomSelectors();
                this.currency = this.$widget.find('.repricing_error').data('currency');
                this.bindToDom();
                Odigeo.trigger(this.id + ':init');
                this.templates = Odigeo.Utils.getTemplates(this.$el, this.tmplSelectors);
            },

            events: {
                'tap .confirmation_info_mytrips': 'onTapConfirmationInfoBtn',
                'tap .my_trips_button': 'onTapConfirmationInfoBtn',
                'tap .room_details_lightBox': 'openConditions',
                'tap .hint_close': 'closeConditions',
            },

            /**
             * save DOM selectors to the widget cache
             */
            cacheDomSelectors: function() {
                this.addSelectorToCache('error-template', this.$widget.find('.error_template'));
                this.addSelectorToCache('confirmationContainer', this.$widget.find('#confirmation_container'));
                this.addSelectorToCache('emergingLayerContainer', this.$widget.find('.emerging_layer'));
            },

            /**
             * save confirmation pending DOM selectors to the widget cache
             */
            cacheConfirmationPendingDomSelectors: function() {
                this.addSelectorToCache('extraInfoBtn', this.$widget.find('.' + this.pendingSelectors.extraInfoBtn));
                this.addSelectorToCache('extraInfoContainer', this.$widget.find('.' + this.pendingSelectors.extraInfoContainer));
                this.addSelectorToCache('angleIcon', this.$widget.find('.' + this.pendingSelectors.angleIcon));
                this.addSelectorToCache('confirmationMsg', this.$widget.find('.' + this.pendingSelectors.confirmationMsg));
                this.addSelectorToCache('confirmationMsgOpen', this.$widget.find('.' + this.pendingSelectors.confirmationMsgOpen));
                this.addSelectorToCache('mainInfoContainer', this.$widget.find('.' + this.pendingSelectors.mainInfoContainer));
            },

            /**
             * bind handlars to DOM events here
             */
            bindToDom: function() {
                if (!this.isDomBinded) {
                    this.isDomBinded = true;
                }
            },

            /**
             * unbind handlars to DOM events here
             */
            unbindFromDom: function() {
                if (this.isDomBinded) {
                    this.isDomBinded = false;
                }
                if (this.isPendingDomBinded) {
                    this.isPendingDomBinded = false;
                    this.$cachedSelectors.extraInfoBtn.unbind(Odigeo.Events.tap);
                }
            },

            fillDaysLeft: function() {
                var container = this.$widget.find('.insert_date');
                var tripDate = new Date(container.attr('data-id'));
                var daysleft = Odigeo.Utils.getRemainingDays(tripDate.getTime());

                Odigeo.UIElements.drawArrow(this.$widget.find('.tip_arrow_confirmation'), 'right');
                container.html(daysleft);
                $('.od-flightdetails-segment-itinerary-title').appendTo($('<div class="hidden"></div>'));
                $('.od-flightdetails-charter').appendTo($('<div class="hidden"></div>'));
                $('.od-itineraryDetails-section-det').appendTo($('<div class="hidden"></div>'));
            },

            fillPrices: function(repricing, div) {
                $(div).find('.dialog_new_price').append(this.formatCurrency(repricing.newPrice));
                $(div).find('.dialog_old_price').append(this.formatCurrency(repricing.oldPrice));
            },

            formatCurrency: function(valueToFormat) {
                valueToFormat = parseFloat(valueToFormat);
                return Odigeo.Utils.formatCurrency(valueToFormat);
            },

            showErrorBrokenFlowDialog: function() {
                Odigeo.UIElements.showBrokenFlowError();
            },

            handleUserInteractionNeeded: function(data) {
                Odigeo.trigger(this.widget.id + ':userInteractionNeeded', data);
            },

            onTapConfirmationInfoBtn: function(data) {
                Odigeo.trigger(`${this.widget.id}:goToMyTrips${this.isMyTripsDataInStorage() ? 'Details' : ''}`, data);
                var flow = this.widget.options.isDynpack ? 'dynpack' : 'flights';
                trackingUtils.trackEventWithCategory(flow + '_confirmation_page_confirmed',
                    'booking_status', 'my_trips_clicks');
            },

            isMyTripsDataInStorage: function() {
                return Odigeo._.isEmpty(Odigeo.Session.get('mytripsData')) === false;
            },

            tripCategoryFromData: function(data) {
                var tripCategory;
                var segments = !Odigeo._.isNull(data.myTrip) ? data.myTrip.itineraries[0].segments : '';
                var tripType =
                    {
                        notValid: 'not_valid',
                        oneWay: 'one_way',
                        multi: 'multi_trip',
                        returnTrip: 'return',
                    };

                switch (segments.length) {
                    case 0:
                        tripCategory = tripType.notValid;
                        break;
                    case 1:
                        tripCategory = tripType.oneWay;
                        break;
                    case 2:
                        var firstCheck = segments[0].departureLocation.cityIataCode === segments[1].arrivalLocation.cityIataCode;
                        var secondCheck = segments[0].arrivalLocation.cityIataCode === segments[1].departureLocation.cityIataCode;
                        tripCategory = firstCheck && secondCheck ? tripType.returnTrip : tripType.multi;
                        break;
                    default:
                        tripCategory = tripType.multi;
                        break;
                }
                return tripCategory;
            },

            createInfoHotelsHero: function(data) {
                var itinerary = data.myTrip.itineraries[0].segments[0];
                var arrivalPlusOneDay = itinerary.arrivalDate + 86400000;
                var checkout = data.tripCategory === 'return' ? data.myTrip.itineraries[0].segments[1].departureDate : arrivalPlusOneDay;
                var previousInfoHotelsHero = Odigeo.Utils.parseJson(Odigeo.Storage.get('infoHotelsHero'));
                var isOutOfDateBooking = !Odigeo._.isNull(previousInfoHotelsHero) && (previousInfoHotelsHero.departureDate < Odigeo.Utils.getToday());
                var bookingDTOList = data.myTrip.itineraries[0].itineraryProviderBookingDTOList[0];
                var infoHotelsHero = {
                    iata: itinerary.arrivalLocation.iata,
                    checkin_monthday: Odigeo.Utils.formatDate(itinerary.arrivalDate, 'justDay', true),
                    checkin_year_month: Odigeo.Utils.formatDate(itinerary.arrivalDate, 'yearMonth', true),
                    checkout_monthday: Odigeo.Utils.formatDate(checkout, 'justDay', true),
                    checkout_year_month: Odigeo.Utils.formatDate(checkout, 'yearMonth', true),
                    selected_currency: data.myTrip.currency,
                    group_adults: bookingDTOList.numAdults,
                    group_children: bookingDTOList.numInfants + bookingDTOList.numChildren,
                    age: [],
                    buyer_name: data.myTrip.buyer.name.toLowerCase(),
                    category: data.tripCategory,
                    departureDate: itinerary.departureDate,
                    arrivalDate: itinerary.arrivalDate,
                    iataDeparture: itinerary.departureLocation.cityIataCode,
                    iataAirportDeparture: itinerary.departureLocation.iata,
                    iataArrival: itinerary.arrivalLocation.cityIataCode,
                };
                Odigeo._.each(data.myTrip.travellers, function(traveller) {
                    if (traveller.ageType !== 'ADULT') {
                        infoHotelsHero.age.push(traveller.birthDate);
                    }
                });
                if (
                    Odigeo._.isNull(previousInfoHotelsHero) ||
                    isOutOfDateBooking ||
                    infoHotelsHero.departureDate < previousInfoHotelsHero.departureDate
                ) {
                    Odigeo.Storage.set('infoHotelsHero', JSON.stringify(infoHotelsHero));
                }
            },

            getHotelData: function(hotelData) {
                return {
                    bannerSuffix: 'hotels',
                    urlArgs: [
                        hotelData.pickupIata,
                        hotelData.checkin_monthday,
                        hotelData.checkin_year_month,
                        hotelData.checkout_monthday,
                        hotelData.checkout_year_month,
                    ],
                };
            },

            getExpediaHotelsData: function(hotelData) {
                return {
                    bannerSuffix: 'hotels',
                    urlArgs: [
                        hotelData.pickupIata,
                        Odigeo.UIElements.translations.expediaHotels.id,
                        hotelData.checkin,
                        hotelData.checkout,
                        hotelData.roomParams,
                        hotelData.currency,
                        hotelData.nPassengers,
                        hotelData.checkin,
                        hotelData.checkout,
                        hotelData.departureIata,
                        hotelData.purchaseDate,
                        hotelData.token,
                    ],
                };
            },

            openConditions: function(event) {
                var $link = $(event.currentTarget);
                var target = $link.data('target');
                this.$el.find(target).addClass('open');
            },

            closeConditions: function(event) {
                var $link = $(event.currentTarget);
                var target = $link.data('target');
                this.$el.find(target).removeClass('open');
            },
        }),

        loadOnReady: function(data) {
            const defer = $.Deferred();
            // Currently all booking status displays the emerging layer apart from accommodation postbooking flow.
            // If you need that some booking status don't display this, then edit `config` variable:
            const resolve = Odigeo._.bind(defer.resolve, defer);
            const reject = Odigeo._.bind(defer.reject, defer);
            const config = {
                bookingStatus: {
                    BOOKING_CONFIRMED: resolve,
                    BOOKING_PENDING: resolve,
                    BOOKING_RETAINED: resolve,
                    BOOKING_PAYMENT_RETRY: reject,
                    BOOKING_STOP: reject,
                    BOOKING_REJECTED: reject,
                    BOOKING_ERROR: reject,
                    BOOKING_REPRICING: reject,
                    BOOKING_USER_INTERACTION_NEEDED: reject,
                },
            };

            defer.then(() => {
                Odigeo.trigger(this.id + ':confirmationPageSuccessfully');
            }, () => {
                Odigeo.trigger(this.id + ':confirmationPageUnsuccessfully');
            });

            if (this.isNotBankTransfer(data)) {
                if (this.isForbiddenNegativeFeeCollection(data.extensions)) {
                    Odigeo.trigger(this.id + ':bookingNegativeFeeLoaded');
                    return;
                }

                this.setConfirmationReachedFlag(data.bookingstatus);
                if (isAccommodationPostBooking()) {
                    data.tripCategory = postBookingTripCategory;
                } else {
                    data.tripCategory = this.view.tripCategoryFromData(data);
                }
                const end = config.bookingStatus[data.bookingstatus];

                this.executeByBookingStatus(data, end);
            } else {
                // Redirect to banktransfer confirmation
                this.loadContentIntoContainer(
                    Odigeo.Settings.property('widgetPartUrlFormatter')(this.name, this.model.bookingBankTransfer),
                    function() {
                        xsellController.then(({default: controller}) => {
                            const cont = controller();
                            cont.setItinerary(getBookingDetails(data));
                            cont.setContainer(this.view.el);
                            cont.createGygWidget();
                        });
                        Odigeo.trigger(this.id + ':confirmationBanktransferLoaded');
                        Odigeo.trigger(this.id + ':bookingConfirmedLoaded', data);
                    }.bind(this),
                    resolve
                );

                Odigeo.Storage.set('confirmationReached', true);
            }
        },

        init: function() {
            this.options = Odigeo.parseOptions(this.options);
        },

        isNotBankTransfer: function(data) {
            return Odigeo._.isNull(data.myTrip) || !data.myTrip.bankTransfer;
        },

        isForbiddenNegativeFeeCollection: function(extensions) {
            var errorObj = {
                'name': 'ERROR_MESSAGE_KEY',
                'value': 'FORBIDDEN_NEGATIVE_FEE_COLLECTION',
            };

            return !Odigeo._.isNull(extensions) && Odigeo._.find(extensions, errorObj);
        },

        setConfirmationReachedFlag: function(bookingStatus) {
            if (Odigeo._.includes(['BOOKING_CONFIRMED', 'BOOKING_PENDING', 'BOOKING_RETAINED', 'BOOKING_REJECTED'], bookingStatus)) {
                var bookingId = Number($('#passengers-manager-wrapper').data('bookingId'));
                var confirmationReachedFlag = !Odigeo._.isNaN(bookingId) ? bookingId : true;

                Odigeo.Storage.set('confirmationReached', confirmationReachedFlag);
            } else {
                Odigeo.Storage.set('confirmationReached', false);
            }
        },

        renderConfirmationWhenBookingApiError: function(confirmationData) {
            this.loadOnReady(confirmationData);
        },

        executeByBookingStatus: function(data, done) {
            const categoryForHotelsHero = data.tripCategory === 'one_way' || data.tripCategory === 'return';
            const hotelsHeroEligible = (Odigeo.Utils.isRequestApp('flights') && categoryForHotelsHero);
            if (data.tripCategory === postBookingTripCategory) {
                this.model.clearShoppingBasket(data.bookingstatus);
            }

            switch (data.bookingstatus) {
                case 'BOOKING_CONFIRMED':
                    $('.od-resultpage-segment-itinerary-title').css('display', 'none');
                    $('.od-resultpage-segment-itinerary-details').css('display', 'none');

                    this.loadContentIntoContainer(
                        Odigeo.Settings.property('widgetPartUrlFormatter')(this.name, this.model.bookingConfirmedUrl),
                        this.onBookingConfirmed.bind(this, data),
                        done
                    );

                    if (hotelsHeroEligible) {
                        this.view.createInfoHotelsHero(data);
                    }
                    break;
                case 'BOOKING_PENDING':
                    this.loadContentIntoContainer(
                        Odigeo.Settings.property('widgetPartUrlFormatter')(this.name, this.model.bookingPendingUrl),
                        this.onBookingPending.bind(this, data),
                        done
                    );

                    if (hotelsHeroEligible) {
                        this.view.createInfoHotelsHero(data);
                    }
                    break;

                case 'BOOKING_RETAINED':
                    this.loadContentIntoContainer(
                        Odigeo.Settings.property('widgetPartUrlFormatter')(this.name, this.model.bookingRetainedUrl),
                        function() {
                            $(this).find('.confirmation_expand_wrapper').each(function() {
                                var $content = $(this).find('.confirmation_expand_content').first();
                                $(this).find('.confirmation_expand').on(Odigeo.Events.tap, function() {
                                    $content.toggleClass('hidden').closest('.scroll_area').trigger('updateDimensions');
                                });
                            });
                        },
                        done
                    );
                    break;

                case 'BOOKING_REJECTED':
                    this.loadContentIntoContainer(
                        Odigeo.Settings.property('widgetPartUrlFormatter')(this.name, this.model.bookingRejectedUrl),
                        function() {
                            Odigeo.trigger(this.id + ':bookingRejectedLoaded');
                        }.bind(this),
                        done
                    );
                    break;

                case 'BOOKING_PAYMENT_RETRY':
                    Odigeo.trigger(this.id + ':bookingPaymentRetryLoaded', data);
                    done();
                    break;

                case 'BOOKING_STOP':
                    this.view.showErrorBrokenFlowDialog();
                    Odigeo.trigger(this.id + ':bookingErrorBrokenFlowDialogLoaded');
                    done();
                    break;

                case 'BOOKING_ERROR':
                    this.view.showErrorBrokenFlowDialog();
                    Odigeo.trigger(this.id + ':bookingErrorLoaded');
                    done();
                    break;

                case 'BOOKING_REPRICING':
                    Odigeo.trigger(this.id + ':bookingRepricingLoaded', {
                        data: data.repricing,
                    });
                    done();
                    break;

                case 'BOOKING_USER_INTERACTION_NEEDED':
                    this.view.handleUserInteractionNeeded(data);
                    done();
                    break;

                default:
                    // unknown status - unexpected error
                    this.view.showErrorBrokenFlowDialog();
                    Odigeo.trigger(this.id + ':bookingErrorBrokenFlowDialogLoaded');
                    done();
                    break;
            }
        },

        loadContentIntoContainer: function(url, callback, done) {
            this.view.$cachedSelectors.confirmationContainer.load(
                url,
                function() {
                    callback.apply(this);
                    done();
                }
            );
        },

        onBookingConfirmed: function(data) {
            this.view.fillDaysLeft();
            this.renderWidgets(data);
            Odigeo.trigger(this.id + ':bookingConfirmedLoaded', data);
        },
        onBookingPending(data) {
            this.renderWidgets(data);
            Odigeo.trigger(this.id + ':bookingPendingLoaded', data);
        },

        renderWidgets: function(data) {
            xsellController.then(({default: controller}) => {
                const cont = controller();
                cont.setItinerary(getBookingDetails(data));
                cont.setContainer(this.view.el);
                cont.renderCrosssellPageWidgets();
            });
        },
    }));

    function getBookingDetails(data) {
        return data.tripCategory === postBookingTripCategory ?
            Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) :
            data.myTrip;
    }

    function isAccommodationPostBooking() {
        return Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'));
    }
